import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import type { VariantProps } from "class-variance-authority"
import { buttonBaseVariants } from "@/v2-ui/button/base/button.base.constants"

export interface ButtonProps
  extends
    React.ComponentProps<"button">,
    VariantProps<typeof buttonBaseVariants> {
  asChild?: boolean
}

const Button = ({
  className,
  variant,
  size,
  isSquare,
  asChild = false,
  ...props
}: ButtonProps) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={buttonBaseVariants({ variant, size, isSquare, className })}
      {...props}
    />
  )
}

Button.displayName = "Button"

export { Button }
